<div class="row">
  <div class="lqd-column col-md-6 col-md-offset-3 text-center">
    <h2 appTranslate="sms.title"></h2>
    <p>{{ getText() }}</p>
    <div class="contact-form contact-form-inputs-filled contact-form-inputs-circle contact-form-button-block contact-form-button-circle mb-60 mt-40">
      <form #formElement="ngForm">
        <app-text-control class="bg-gray" [form]="formElement" [control]="control"></app-text-control>
      </form>
      <div>
        <a (click)="validate()" [class.disabled]="!canGoNext()" class="btn btn-solid text-uppercase btn-bordered border-thin circle font-size-12 lh-2 font-weight-bold ltr-sp-05 mb-2 validate" appTranslate="sms.validate"></a>
      </div>
      <div>
        <a (click)="sendAgain()" class="btn btn-solid text-uppercase btn-bordered border-thin circle font-size-12 lh-2 font-weight-bold ltr-sp-05 mb-2 send-again" appTranslate="sms.send-again"></a>
      </div>
      <div>
        <a (click)="back()" class="btn btn-solid text-uppercase btn-bordered border-thin circle font-size-12 lh-2 font-weight-bold ltr-sp-05 mb-2 back" appTranslate="back"></a>
      </div>
    </div>
  </div>
</div>
